export const normalizeAvatarSrc = (avatarValue) => {
  if (!avatarValue) return "";

  if (typeof avatarValue === "string") {
    const trimmed = avatarValue.trim();
    if (!trimmed) return "";

    // Handle old JSON-stringified avatar values like "[]" or "[\"url\"]".
    if (trimmed.startsWith("[") || trimmed.startsWith("{")) {
      try {
        const parsed = JSON.parse(trimmed);
        return normalizeAvatarSrc(parsed);
      } catch (error) {
        return "";
      }
    }

    return /^https?:\/\//i.test(trimmed) ? trimmed : "";
  }

  if (Array.isArray(avatarValue)) {
    return normalizeAvatarSrc(avatarValue[0]);
  }

  if (typeof avatarValue === "object") {
    return normalizeAvatarSrc(avatarValue.url || avatarValue.src || "");
  }

  return "";
};
